var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWeibo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 20
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E6162D",
    fillRule: "nonzero",
    d: "M10.098 18.323c-3.977.391-7.414-1.406-7.672-4.02-.259-2.609 2.759-5.047 6.74-5.441 3.979-.394 7.413 1.404 7.671 4.018.259 2.6-2.759 5.049-6.737 5.439l-.002.004zm7.556-9.289c.375-.977.42-1.804 0-2.404-.781-1.112-2.915-1.053-5.364-.03 0 0-.766.331-.571-.271.376-1.217.315-2.224-.27-2.809-1.338-1.337-4.869.045-7.888 3.08C1.309 8.87 0 11.273 0 13.348c0 3.981 5.099 6.395 10.086 6.395 6.536 0 10.888-3.801 10.888-6.82 0-1.822-1.547-2.854-2.915-3.284-.346-.095-.57-.17-.405-.605z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M10.496 10.873c1.96.507 2.961 2.356 2.161 4.149-.814 1.838-3.149 2.819-5.132 2.179-1.912-.619-2.722-2.506-1.886-4.21.824-1.668 2.964-2.611 4.857-2.118zM9.05 15.219c.378-.62.18-1.329-.442-1.592-.617-.26-1.414.006-1.793.601-.387.602-.206 1.314.406 1.593.621.282 1.445.014 1.829-.602zm1.27-1.627l-.014.028c.135-.241.059-.511-.18-.601-.236-.106-.534.013-.672.24-.136.225-.059.496.177.586.24.1.548-.016.689-.253z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F90",
    d: "M19.967 4.557a3.101 3.101 0 00-2.96-.962.786.786 0 00-.616.932.79.79 0 00.932.602 1.512 1.512 0 011.442.465c.376.421.466.977.316 1.473a.786.786 0 00.51.992.813.813 0 00.992-.512 3.108 3.108 0 00-.646-3.035l.03.045z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F90",
    d: "M22.385 2.362C20.809.605 18.48-.057 16.331.394a.91.91 0 00-.706 1.081.91.91 0 001.082.707 4.5 4.5 0 014.296 1.383 4.533 4.533 0 01.947 4.416.91.91 0 00.586 1.157c.479.165.991-.104 1.157-.586a6.387 6.387 0 00-1.338-6.235l.03.045z"
  }))));
}

export default SvgWeibo;